import Phaser from 'phaser';
import type { LevelDefinition } from '../types';
import { PuzzleScene, type PuzzleCallbacks } from './PuzzleScene';

export interface PuzzleHandle {
  destroy: () => void;
  hint: () => void;
  reset: () => void;
  solveForTest: () => void;
}

export function createPuzzleGame(
  parent: HTMLElement,
  level: LevelDefinition,
  callbacks: PuzzleCallbacks,
): PuzzleHandle {
  const portrait = window.matchMedia('(max-width: 720px)').matches;
  const scene = new PuzzleScene(level, callbacks);
  const game = new Phaser.Game({
    type: Phaser.AUTO,
    parent,
    width: portrait ? 720 : 1240,
    height: portrait ? 1180 : 760,
    backgroundColor: '#07121b',
    scene: [scene],
    scale: {
      mode: Phaser.Scale.FIT,
      autoCenter: Phaser.Scale.CENTER_BOTH,
    },
    render: {
      antialias: true,
      roundPixels: true,
      powerPreference: 'high-performance',
    },
    audio: { noAudio: true },
  });

  game.canvas.setAttribute('aria-label', `${level.title}谜题画面。可使用鼠标、触摸或键盘完成。`);
  game.canvas.setAttribute('role', 'application');
  game.canvas.tabIndex = 0;

  return {
    destroy: () => game.destroy(true),
    hint: () => scene.showHint(),
    reset: () => scene.resetPuzzle(),
    solveForTest: () => scene.solveForTest(),
  };
}
